// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

import type { UserWithOrg } from '../types/user';

/** IAM's identity provider for an employee who signs in with their company account. */
export const FEDERATED_IDENTITY_PROVIDER = 'EntraExternalFederated';
const AWAITING_FIRST_SIGN_IN = 'AWAITING_FIRST_SIGN_IN';

type AccountFields = Pick<UserWithOrg, 'identity_provider' | 'identity_provider_sync_status'>;

/** Signs in with their company account, so has no Helios password. */
export function isFederated(user: AccountFields): boolean {
  return user.identity_provider === FEDERATED_IDENTITY_PROVIDER;
}

/** A pre-provisioned employee who hasn't signed in yet. */
export function isAwaitingFirstSignIn(user: AccountFields): boolean {
  return isFederated(user) && user.identity_provider_sync_status === AWAITING_FIRST_SIGN_IN;
}

/** "Company sign-in" or "Local" — how this user gets into Helios. */
export function accountTypeLabel(user: AccountFields): string {
  return isFederated(user) ? 'Company sign-in' : 'Local';
}

/** The lower-cased domain of an email address, or null when it has none. */
export function emailDomain(email: string): string | null {
  const at = email.trim().lastIndexOf('@');
  if (at < 0) return null;
  const domain = email
    .trim()
    .slice(at + 1)
    .toLowerCase();
  return domain || null;
}
